import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { VplRouter } from '../../services/vpl-router/vpl-router';

export const Auth = {
    computed: {
        ...mapState(vplSiteStore, ['IS_AUTHORIZED'])
    },
    props: {
        structKey: [String, Number]
    },
    data(){
        return {
            authType: 'email',
            codeInterval: false,
            codeTimer: 0,
            codeFormatTimer: '',
            loginPhoneNumber: '',
            loginPhoneRaw: '',
            rememberMe: false
        }
    },
    updated(){

    },
    mounted(){
        $(this.$el).find('.js-phone').each(function(){
            new Cleave($(this)[0], {
                numericOnly: true,
                delimiters: [" (", ") ", "-", "-"],
                blocks: [1, 3, 3, 2, 2],
                delimiterLazyShow: true
            });
        });

        $('.js-pass-rec').click(function(e){
            e.preventDefault();
            $('#entrance').modal('hide');
            $('#modalRegisterPhone').modal('hide');
            $('#modalRegisterEmail').modal('hide');
            $('#registration').modal('hide');
            $('#recovery').modal('show');
        });

        $('.js-reg-new').click(function(e){
            e.preventDefault();
            $('#entrance').modal('hide');
            $('#modalRegisterPhone').modal('hide');
            $('#modalRegisterEmail').modal('hide');
            $('#recovery').modal('hide');
            $('#registration').modal('show');
            /*

            if (!$(this).hasClass('js-forgot-page')) {
                $('#entrance').on('hidden.bs.modal', function (e) {
                $('#registration').modal('show');
                $('#entrance').unbind('hidden.bs.modal');
                });
            } else {
                $('#registration').modal('show');
            }*/
        });


    },
    methods: {
        phoneMailMask(){
            const value = String($(this.$el).find('input[name=entrance-input]').val() || '');
            this.authType = /^[\d\s()\-+]+$/.test(value) && /\d/.test(value)
                ? 'phone'
                : 'email';

            if (this.authType !== 'phone') {
                this.loginPhoneRaw = '';
            }
        },
        refreshClock(){
            let time = this.codeTimer - Date.parse(new Date()),
                minutes = time <= 0 ? 0 : Math.floor((time / 1000 / 60) % 60),
                seconds = time <= 0 ? 0 : Math.floor((time / 1000) % 60);

            this.codeFormatTimer = (minutes >= 0 && minutes < 10 ? "0" + minutes : minutes) +
                    ":" +
                (seconds >= 0 && seconds < 10 ? "0" + seconds : seconds);

            if (minutes * 60 + seconds <= 0) {
                this.codeTimer = 0;
                this.codeFormatTimer = '';
                clearInterval(this.codeInterval);
            }
        },
        sendPhoneCode(){
            const phone = this.loginPhoneRaw;

            $('#entrance').modal('hide');
            $.ajax({
                url: '/ajax/authcontroller.php',
                method: 'POST',
                data: {'action': 'phoneLogin', 'phone': phone, 'code': 'get', 'sessid': BX.bitrix_sessid()},
                success: (response)=>{



                    response = JSON.parse(response);
                    if (
                        (response.TIME && response.STATUS === undefined) ||
                        response.STATUS == "OK"
                    ) {
                        //код отправлен
                        this.codeTimer = parseInt(response.TIME) * 1000;
                        clearInterval(this.codeInterval);
                        this.codeInterval = setInterval( $.proxy(this.refreshClock, this), 1000 );
                        this.showPhoneForm();
                    }else if(response.STATUS !== 'TIMER'){
                        $('#modalRegisterPhone').modal('hide');
                        $('#dialog').find('.js-text').text('К сожалению, авторизация по номеру телефона в данный момент недоступна. Попробуйте позднее или авторизуйтесь другим способом.');
                        $('#dialog').modal();
                    }else{
                        this.showPhoneForm();
                    }
                }
            });
        },
        resendCode(){
            if (this.loginPhoneRaw) {
                this.sendPhoneCode();
            }
        },
        checkCode(e){
            let code = $(e.target).val();

            if (code.length == 4) {
                $(e.target).addClass("disable");
                $(e.target).parent().removeClass("is-error");
                $.ajax({
                    url: '/ajax/authcontroller.php',
                    method: 'POST',
                        data: {
                            'action': 'phoneLogin',
                            code: code,
                            phone: this.loginPhoneRaw,
                            remember: this.rememberMe ? 'Y' : 'N',
                            'sessid': BX.bitrix_sessid()
                        },
                    success: (response) => {
                        response = JSON.parse(response);
                        $(e.target).removeClass("disable");
                        if (response.STATUS == "OK") {
                            $('#modalRegisterPhone').modal('hide');

                            if(response.METHOD == 'REG'){
                                $('#success-reg').on('hidden.bs.modal', function(){
                                    //window.location.reload();
                                    window.location.reload();
                                });
                                $('#success-reg').modal();
                            }else{
                                $('#success-auth').on('hidden.bs.modal', function(){
                                    //window.location.reload();
                                    window.location.reload();
                                });
                                $('#success-auth').modal();
                            }


                        } else {
                            $(e.target).parent().addClass("is-error");
                        }
                    },
                });
            }
        },
        processAuthStart(e){

            this.phoneMailMask();

            let input = $(e.target).closest('form').find('input[name="entrance-input"]');

            if(!input.val()){
                input.parent().addClass('is-error');
                return;
            }else{
                input.parent().removeClass('is-error');
            }

            let politic = $(e.target).closest('form').find('input[name=politic]').prop('checked');
            if(!politic){
                $(e.target).closest('form').find('input[name=politic]').parent().addClass('is-error');
                return;
            }else{
                $(e.target).closest('form').find('input[name=politic]').parent().removeClass('is-error');
            }



            if(this.authType == 'phone'){
                const phone = input.val().replace(/\D/g, '');

                if (!/^7\d{10}$/.test(phone)) {
                    input.parent().addClass('is-error');
                    return;
                }

                this.loginPhoneRaw = phone;
                this.loginPhoneNumber = input.val();
                this.sendPhoneCode();
            }else{
                let modal = $('#modalRegisterEmail');
                modal.find('input[name=mail]').val(input.val());
                $(e.target).closest('.modal').modal('hide');
                modal.modal();
            }
        },
        actionAuthEmail(e){

            let form = $(e.target);

            let politic = form.find('input[name=politic]').prop('checked');
            if(!politic){
                form.find('input[name=politic]').parent().addClass('is-error');
                return;
            }else{
                form.find('input[name=politic]').parent().removeClass('is-error');
            }

            $.ajax({
                url: '/ajax/authcontroller.php',
                method: 'POST',
                data: {
                    'action': 'emailLogin',
                    'e': form.find('input[name=mail]').val(),
                    'p': form.find('input[name=pass]').val(),
                    'remember': this.rememberMe ? 'Y' : 'N',
                    'sessid': BX.bitrix_sessid()
                },
                success: function(response){
                    response = JSON.parse(response);
                    form.find('.is-error').removeClass('is-error');
                    if(response.STATUS == 'OK'){
                        form.closest('.modal').modal('hide');
                        form.find('.js-form-error').html('');
                        $('#success-auth').on('hidden.bs.modal', function(){
                            //window.location.reload();
                            window.location.reload();
                        });
                        $('#success-auth').modal();
                    }else{
                        form.find('.js-form-error').html(response.error);
                        form.find('input[name=mail],input[name=pass]').parent().addClass('is-error');
                    }
                }
            });

        },
        actionRestorePass(e){
            let form = $(e.target),
                input = form.find('input[name=mail]');

            if(!input.val().length){
                input.parent().addClass('is-error');
            }else{
                input.parent().removeClass('is-error');
            }

            $.ajax({
                url: '/ajax/authcontroller.php',
                method: 'POST',
                data: {'action': 'restore', 'e': form.find('input[name=mail]').val(), 'sessid': BX.bitrix_sessid()},
                success: function(response){
                    response = JSON.parse(response);
                    form.find('.is-error').removeClass('is-error');
                    if(response.STATUS == 'OK'){
                        form.closest('.modal').modal('hide');
                        $('#dialog').find('.js-text').text('Новый пароль выслан на указанную почту');
                        $('#dialog').modal();
                    }else{

                        if(response.message){
                            $('#dialog').find('.js-text').text(response.message);
                            $('#dialog').modal();
                        }
                        form.find('input[name=mail],input[name=pass]').parent().addClass('is-error');
                    }
                }
            });

        },
        submitRegForm(e){
            let form = $(e.target),
                data = {};

            if(form.find('input[name=politic]').prop('checked')){

                data['action'] = 'reg';
                data['name'] = form.find('input[name=name]').val();
                data['lastname'] = form.find('input[name=lastname]').val();
                data['mail'] = form.find('input[name=mail]').val();
                data['phone'] = form.find('input[name=phone]').val();
                data['pass'] = form.find('input[name=pass]').val();
                data['repass'] = form.find('input[name=repass]').val();
                data['subscription'] = ( form.find('input[name=subscription]').prop('checked') ? 'Y' : '');
                data['sessid'] = BX.bitrix_sessid();

                form.find('.is-error').removeClass('is-error');

                $.ajax({
                    url: '/ajax/authcontroller.php',
                    method: 'POST',
                    data: data,
                    success: (response) => {
                        response = JSON.parse(response);
                        form.find('.is-error').removeClass('is-error');
                        form.find('.js-form-error').html('');
                        if(response.STATUS == 'OK'){
                            form.closest('.modal').modal('hide');

                            $('#success-reg').on('hidden.bs.modal', function(){
                                //window.location.reload();
                                window.location.reload();
                            });

                            $('#success-reg').modal();

                        }else{

                            for(let i in response.ERRORS){

                                form.find('input[name='+i+']').parent().addClass('is-error');
                                form.find('input[name='+i+']').parent().find('.field__error-text').html(response.ERRORS[i])
                            }
                            if (response.TEXT_ERROR) {
                                form.find('.js-form-error').html(response.TEXT_ERROR);
                            }
                            // alert(response.TEXT_ERROR)
                        }
                    }
                });

            }else{

                form.find('input[name=politic]').parent().addClass('is-error');

            }

        },
        showAuthForm(){
            $('#entrance').modal();
            $('#modalRegisterPhone').modal('hide');
            $('#modalRegisterEmail').modal('hide');
            $('#recovery').modal('hide');
            $('#registration').modal('hide');
        },
        showPhoneForm(){
            const codeInput = $('#modalRegisterPhone').find(
                'input[name=entrance-phone]'
            );

            codeInput.val('').removeClass('disable');
            codeInput.parent().removeClass('is-error');

            $('#modalRegisterPhone').modal();
            $('#entrance').modal('hide');
            $('#modalRegisterEmail').modal('hide');
            $('#recovery').modal('hide');
            $('#registration').modal('hide');
        },


        changePassInputType(e){
            let btn = $(e.target),
                input = btn.parent().find('input');

            if (input.attr('type') == 'password') {
                btn.addClass('is-show');
                input.attr('type', 'text');
            } else {
                btn.removeClass('is-show');
                input.attr('type', 'password');
            }
        }
    },
    template: `

    <div v-if="!this.IS_AUTHORIZED">

        <div class="modal fade modal-entrance modal-small hide" id="entrance"  tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">Вход или регистрация</div>
                        <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">
                                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <div class="field js-material-input is-required">
                                <input class="field__input" @input="phoneMailMask()" id="entrance-pass1" name="entrance-input" autocomplete="off">
                                <label class="field__label" for="entrance-pass1">Введите номер телефона или e-mail</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div
                                class="checkbox checkbox--remember"
                                style="margin: 14px 0 20px;"
                            >
                                <input
                                    v-model="rememberMe"
                                    type="checkbox"
                                    name="remember"
                                    class="checkbox__input"
                                    id="remember-auth-start"
                                >
                                <label for="remember-auth-start" class="checkbox__label">
                                    Запомнить меня на этом компьютере
                                </label>
                            </div>
                            <div class="modal-regist">
                                Если у вас ещё нет аккаунта, <a href="#" class="reg-new js-reg-new">зарегистрируйтесь</a>
                                прямо сейчас. Это займет всего пару минут.
                            </div>
                            <div class="form__submit">
                                <div class="form__submit-container">
                                    <button type="submit" @click.prevent="processAuthStart($event)" class="btn btn--green">
                                        Войти
                                    </button>
                                    <a href="#" class="pass-rec js-pass-rec">
                                        Восстановление пароля
                                    </a>
                                </div>
                                <div class="checkbox">
                                <input type="checkbox" checked name="politic" class="checkbox__input js-politic js-politic-auto" id="politic-auth-modal">
                                <label for="politic-auth-modal" class="checkbox__label">
                                    При нажатии на кнопку «Отправить» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>


        <div class="modal fade modal-entrance modal-small hide" id="modalRegisterPhone"  tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">Вход или регистрация</div>
                        <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">
                                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="" @submit.prevent>
                            <div class="modal-regist">
                                Мы отправили код подтверждения <br>
                                на номер <span class="tel">{{ this.loginPhoneNumber }}</span> <a href="#" @click.prevent="this.showAuthForm()">Изменить</a>
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input" @input="this.checkCode($event)" name="entrance-phone" id="entrance-mail-2" autocomplete="off" type="text">
                                <label class="field__label" for="entrance-mail-2">Введите код из смс</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div v-if="this.codeTimer > 0" class="modal-pas">
                                Получить новый код можно через <span>{{ this.codeFormatTimer }}</span>
                            </div>
                            <div v-else class="modal-pas">
                                <a href="#" @click.prevent="this.resendCode()">Получить новый код</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade modal-entrance modal-small modal-placeholder hide" id="modalRegisterEmail"  tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">Вход или регистрация</div>
                        <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">
                                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="" @submit.prevent="this.actionAuthEmail($event)">
                            <div class="field js-material-input is-required">
                                <input class="field__input field__input--placeholder" name="mail" id="entrance-mail" autocomplete="off" type="text" placeholder="Введите e-mail">
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input" name="pass" id="entrance-pass" autocomplete="off" type="password">
                                <a href="#" @click.prevent="this.changePassInputType($event)" class="field__pass js-field-pass"></a>
                                <label class="field__label" for="entrance-pass">Введите пароль</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div
                                class="checkbox checkbox--remember"
                                style="margin: 14px 0 20px;"
                            >
                                <input
                                    v-model="rememberMe"
                                    type="checkbox"
                                    name="remember"
                                    class="checkbox__input"
                                    id="remember-auth-email"
                                >
                                <label for="remember-auth-email" class="checkbox__label">
                                    Запомнить меня на этом компьютере
                                </label>
                            </div>
                            <div class="modal-regist">
                                Если у вас ещё нет аккаунта, <a href="#" class="js-reg-new">зарегистрируйтесь</a>
                                прямо сейчас. Это займет всего пару минут.
                            </div>
                            <div class="form__submit">
                                <span class="form__submit-error js-form-error"></span>
                                <div class="form__submit-container">
                                    <button type="submit" class="btn btn--green">
                                        Войти
                                    </button>
                                    <a href="#" class="pass-rec js-pass-rec">
                                        Восстановление пароля
                                    </a>
                                </div>
                                <div class="checkbox">
                                <input type="checkbox" name="politic" class="checkbox__input js-politic js-politic-auto"
                                    id="politic-modal-auth" checked="">
                                <label for="politic-modal-auth" class="checkbox__label">
                                    При нажатии на кнопку «Отправить» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>


        <div class="modal fade modal-entrance modal-small modal-register hide" id="recovery"  tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">Восстановление <br> пароля</div>
                        <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">
                                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="" @submit.prevent="actionRestorePass($event)">
                            <div class="modal-regist">
                                Укажите почту регистрации, мы вышлем вам ссылку для восстановления пароля
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input" name="mail" id="entrance-mail-req" autocomplete="off" type="text">
                                <label class="field__label" for="entrance-mail-req">Введите свой e-mail</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div class="form__submit">
                                <div class="form__submit-container">
                                    <button type="submit" class="btn btn--green">
                                        Восстановить
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade modal-registration modal-small hide" id="registration"  tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">Зарегистрироваться</div>
                        <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">
                                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="" @submit.prevent="this.submitRegForm($event)">
                            <div class="field js-material-input is-required">
                                <input class="field__input" name="name" id="registration-name-1" autocomplete="off" type="text">
                                <label class="field__label" for="registration-name-1">Имя</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input" name="lastname" id="registration-name-2" autocomplete="off" type="text">
                                <label class="field__label" for="registration-name-2">Фамилия</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input" name="mail" id="registration-mail" autocomplete="off" type="text">
                                <label class="field__label" for="registration-mail">Электронная почта</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input js-phone" name="phone" id="registration-tel" autocomplete="off" type="text">
                                <label class="field__label" for="registration-tel">Телефон</label>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input" name="pass" id="registration-name-3" autocomplete="off" type="password">
                                <label class="field__label" for="registration-name-3">Введите пароль</label>
                                <a href="#" @click.prevent="this.changePassInputType($event)" class="field__pass js-field-pass"></a>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>
                            <div class="field js-material-input is-required">
                                <input class="field__input" name="repass" id="registration-name-4" autocomplete="off" type="password">
                                <label class="field__label" for="registration-name-4">Подтвердите пароль</label>
                                <a href="#" @click.prevent="this.changePassInputType($event)" class="field__pass js-field-pass"></a>
                                <span class="field__error-text">Заполнено некорректно.</span>
                            </div>

                            <div class="form__submit">
                                <span class="form__submit-error js-form-error"></span>
                                <div class="checkbox__wp">
                                    <div class="checkbox checkbox--subscription">
                                        <input type="checkbox" name="subscription" class="checkbox__input" id="subscription">
                                        <label for="subscription" class="checkbox__label">
                                            Получать новости и акции по email.
                                            <a href="/soglasie-na-rassylku/" target="_blank" rel="noopener">Согласие на рассылку</a>
                                        </label>
                                    </div>
                                    <div class="checkbox">
                                        <input type="checkbox" checked name="politic" class="checkbox__input js-politic js-politic-auto" id="politic">
                                        <label for="politic" class="checkbox__label">
                                            При нажатии на кнопку «Регистрация» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                                            </label>
                                    </div>
                                </div>
                                <div class="form__submit-container">
                                    <button type="submit" class="btn btn--green">
                                        Регистрация
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>

    `
}
